<template>
  <div class="mentIndex">
    <div class="home_con_index">
      <div style="width:306px"></div>
      <div class="mentCon">
        <div class="ment_title">安全</div>
        <p>1.1 认证方法</p>
        <span
          >平台与聚能之间进行信息交换前，都需要完成平台认证。认证成功后授予
          Token, 之后每次向服务提供方请求资源时都需要带上签发的 Token,
          认证成功后，才返回请求数据。Token 有效期由服务提供方设置，并将 Token
          失效时间一并返回，请求发起方在 Token 失效后需重新获取 Token.</span
        >
        <img src="@/assets/ment/11.png" alt="" />
        <p>1.2 密钥管理和使用</p>
        <small>1.2.1 密钥分类</small>
        <img src="@/assets/ment/22.png" alt="" />
        <p>1.2.1 密钥的使用</p>
        <img src="@/assets/ment/99.png" alt="" />
        <p>1.2.3 签名规范</p>
        <img src="@/assets/ment/98.png" alt="" />
        <p>1.3 接口规范</p>
        <span>概述：此接口用于请求前获取凭证 </span><br />
        <span>接口名称：query_token</span><br />
        <span>接口使用方法：由服务实现方实现此接口，由需要方调用。</span
        ><br /><br />
        <small>请求参数：</small>
        <img style="margin-top: 0px" src="@/assets/ment/33.png" alt="" />
        <small>返回值：</small>
        <img style="margin-top: 0px" src="@/assets/ment/44.png" alt="" />
      </div>
    </div>
  </div>
</template>


<script>
import Ment from "@/components/ment";
export default {
  components: {
    Ment,
  },
};
</script>

<style scoped>
.home_con_index {
  display:flex;
   
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/page/document/documentb.vue